<template>
  <div class="l-default__sidebar__logo-area">
    <img
      v-if="width > 0"
      :width="width"
      :src="require('@/assets/images/Logo.png')"
      alt=""
    />
    <img
      v-else
      :src="require('@/assets/images/Logo.png')"
      alt=""
      class="l-default__sidebar__logo-area__image"
    />
  </div>
</template>

<script>
export default {
  props: {
    width: {
      default: 0,
    },
  },
};
</script>

<style></style>
